import React, { useState } from "react";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Repeatability_Report_Filter from "./repeatability_report_filter/Repeatability_Report_Filter";
import Repeatability_Report_Table from "./repeatability_report_table/Repeatability_Report_Table";
import {
  GetCustomerReport,
  GetRepeatbilityReport,
} from "../../../../../../../features/admin/report_generator/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../../utils/fixIDS";

const Repeatability_Report = ({
  data,
  setCurrentPage,
  currentPage,
  setSearchParams,
  searchParams,
  activeSelectionTypeId,
}) => {
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();
  const [showLottie, setShowLottie] = useState(true);
  const [reportPath, setReportPath] = useState("");
  const reportgenerate = async () => {
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(
      GetRepeatbilityReport({
        page: 1,
        per_page: 10,
        selection_type_id: activeSelectionTypeId,
        test_type_id: searchParams?.test_type_id?.value,
        checked_by_id: searchParams?.checked_by_id?.value,
        certified_value: searchParams?.certified_value,
        end_date: searchParams?.end_date,
        start_date: searchParams?.start_date,
        title: "Repeatbility Report",
      }),
    );

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      setReportPath(path);
      setShowLottie(false);
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };


  const permissions = useSelector((state) => state.auth.permissions);
  const haveReportPermission = permissions?.includes(FixIDS.repetability_report.Report);

  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Repeatability_Report_Filter
          setShow={setShow}
          reportgenerate={reportgenerate}
          setSearchParams={setSearchParams}
        />
      </div>

      <div className="report_table_div">
        { haveReportPermission && <Repeatability_Report_Table
          data={data}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />}
      </div>
      <Common_Report_Offcanvas
        reportPath={reportPath}
        reportgenerate={reportgenerate}
        setShowLottie={setShowLottie}
        showLottie={showLottie}
        title={"Repeatability Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Repeatability_Report;
